import React from 'react';
import { useTranslation } from 'react-i18next';
import { AlertTriangle } from 'lucide-react';

interface BillingValidationModalProps {
    isOpen: boolean;
    onClose: () => void;
}

export const BillingValidationModal: React.FC<BillingValidationModalProps> = ({ isOpen, onClose }) => {
    const { t } = useTranslation('billing');
    if (!isOpen) return null;
    return (
        <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4 animate-fadeIn">
            <div className="bg-white rounded-2xl w-full max-w-sm p-6 shadow-xl text-center">
                <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4 text-orange-600">
                    <AlertTriangle size={24} />
                </div>
                <h3 className="font-bold text-xl text-slate-900 mb-2">{t('modals.missing_details.title')}</h3>
                <p className="text-slate-500 mb-6 text-sm">
                    {t('modals.missing_details.message')}
                </p>
                <button
                    onClick={onClose}
                    className="w-full bg-black text-white py-3 rounded-xl font-bold hover:bg-slate-800 transition shadow-lg"
                >
                    {t('modals.missing_details.button')}
                </button>
            </div>
        </div>
    );
};
